export default {"src":"/_next/static/media/pre.11595d89.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};